import styled from 'styled-components';
import { FlexListItem } from 'styles';

export const Header = styled.header`
  position: fixed;
  top: 0;
  width: 100vw;
  background-color: white;
  border-bottom: 1px solid ${({ theme }) => theme.colors.fill005};
  z-index: 1;
`;

export const HeaderListItem = styled(FlexListItem)`
  transition: opacity 150ms;
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      opacity: 0.6;
    }
  }
`;

export const HeaderLink = styled.a`
  color: inherit;
  text-decoration: none;
`;

export const Nav = styled.nav`
  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    & > ul {
      width: max-content;
      margin: 0 auto;
    }
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
